<div class="dashboard-container">
  <!-- Header -->
  <app-staff-header [currentUser]="currentUser" (logout)="onLogout()">
  </app-staff-header>

  <!-- Main Content -->
  <div class="dashboard-content">
    <!-- Navigation -->
    <app-staff-nav [isMobileMenuOpen]="isMobileMenuOpen" (navigate)="onNavigate($event)"
      (closeMobileMenu)="closeMobileMenu()">
    </app-staff-nav>

    <!-- Content Area -->
    <div class="dashboard-main">
      <div class="main-content">
        <!-- Page Header -->
        <div class="content-header">
          <h1 class="page-title">จัดการหลักสูตร</h1>
          <p class="page-subtitle">ระบบจัดการข้อมูลหลักสูตร VAT</p>
        </div>

        <!-- Mock Data Warning -->
        <ngb-alert *ngIf="showMockDataWarning" type="info" [dismissible]="false" class="mb-3">
          <strong>ข้อมูลตัวอย่าง:</strong>
          ระบบกำลังใช้ข้อมูลตัวอย่างเนื่องจากไม่สามารถเชื่อมต่อ backend API ได้
        </ngb-alert>

        <!-- Error Alert -->
        <ngb-alert *ngIf="error" type="danger" [dismissible]="true" class="mb-3">
          {{ error }}
        </ngb-alert>

        <!-- Filters Section -->
        <div class="filters-section card shadow-sm border-0 mb-4">
          <div class="card-header bg-white border-0 py-3">
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <i class="bi bi-funnel-fill text-primary me-2 fs-5"></i>
                <h5 class="mb-0 fw-bold">ค้นหาและกรองข้อมูล</h5>
              </div>
              <div class="filters-actions d-flex gap-2">
                <button type="button" class="btn btn-success" (click)="openCreateCourseModal()"
                  ngbTooltip="สร้างคอร์สอบรม/สัมมนาใหม่">
                  <i class="bi bi-plus-circle me-2"></i>
                  สร้างคอร์สอบรม
                </button>
                <button type="button" class="btn btn-outline-secondary" (click)="clearFilters()"
                  ngbTooltip="ล้างตัวกรองทั้งหมด">
                  <i class="bi bi-x-circle me-2"></i>
                  ล้างตัวกรอง
                </button>
              </div>
            </div>
          </div>

          <div class="card-body">
            <div class="row g-3 align-items-end">
              <!-- Search Term -->
              <div class="col-md-6 col-lg-4">
                <label for="searchTerm" class="form-label fw-semibold">
                  <i class="bi bi-search me-1"></i>
                  ค้นหาชื่อหลักสูตร
                </label>
                <div class="input-group">
                  <span class="input-group-text bg-light border-end-0">
                    <i class="bi bi-search text-muted"></i>
                  </span>
                  <input type="text" class="form-control border-start-0 ps-0" id="searchTerm"
                    [(ngModel)]="filters.searchTerm"
                    placeholder="พิมพ์ชื่อหลักสูตร, คำอธิบาย, ผู้สอน..."
                    (keyup.enter)="applyFilters()">
                </div>
              </div>

              <!-- รับรองโดย กลต. Filter -->
              <div class="col-md-3 col-lg-3">
                <label for="certSec" class="form-label fw-semibold">
                  <i class="bi bi-patch-check-fill me-1"></i>
                  รับรองโดย กลต.
                </label>
                <select class="form-select" id="certSec" [(ngModel)]="filters.certificationBySEC" (change)="applyFilters()">
                  <option value="">ทั้งหมด</option>
                  <option value="true">Yes</option>
                  <option value="false">No</option>
                </select>
              </div>

              <!-- ช่วงเวลาอบรม/สัมมนา Filter -->
              <div class="col-md-3 col-lg-3">
                <label for="dateRange" class="form-label fw-semibold">
                  <i class="bi bi-calendar-range me-1"></i>
                  ช่วงเวลาอบรม/สัมมนา
                </label>
                <select class="form-select" id="dateRange" [(ngModel)]="filters.dateRange" (change)="applyFilters()">
                  <option value="">ทั้งหมด</option>
                  <option value="3m">ย้อนหลัง 3 เดือน</option>
                  <option value="6m">ย้อนหลัง 6 เดือน</option>
                  <option value="1y">ย้อนหลัง 1 ปี</option>
                  <option value="3y">ไม่เกิน 3 ปี</option>
                </select>
              </div>

              <!-- Apply Filters Button -->
              <div class="col-12 col-lg-12">
                <div class="d-flex gap-2">
                  <button type="button" class="btn btn-primary" (click)="applyFilters()">
                    <i class="bi bi-search me-2"></i>
                    ค้นหา
                  </button>
                  <button type="button" class="btn btn-outline-secondary" (click)="clearFilters()"
                    ngbTooltip="ล้างตัวกรอง / รีเซ็ต">
                    <i class="bi bi-arrow-clockwise me-2"></i>
                    รีเซ็ต
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Status Tabs -->
        <div class="status-tabs mb-3" role="tablist" aria-label="สถานะคอร์สอบรม/สัมมนา">
          <button type="button" class="status-tab" *ngFor="let tab of statusTabs"
            [class.active]="isActiveStatusTab(tab)"
            [ngClass]="'status-tab-' + tab.color"
            role="tab" [attr.aria-selected]="isActiveStatusTab(tab)"
            (click)="selectStatusTab(tab)">
            <span class="status-tab-dot"></span>
            <span class="status-tab-name">{{ tab.name }}</span>
            <span class="status-tab-count">{{ tab.count }}</span>
          </button>
        </div>

        <!-- Results Section -->
        <div class="results-section">
          <div class="results-header">
            <h3>ผลการค้นหา</h3>
            <div class="results-meta">
              <span class="result-count">
                พบ {{ collectionSize }} หลักสูตร
                <span *ngIf="page > 1 || collectionSize > pageSize">
                  (แสดงหน้า {{ page }} จาก {{ Math.ceil(collectionSize / pageSize) }})
                </span>
              </span>
              <small class="text-muted d-block mt-1">
                <i class="fas fa-info-circle me-1"></i>
                คลิกที่แถวเพื่อดูรายละเอียดหลักสูตร
              </small>
            </div>
          </div>

          <!-- Loading State -->
          <div *ngIf="isLoading" class="loading-state">
            <div class="text-center py-4">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">กำลังโหลด...</span>
              </div>
              <p class="mt-2 text-muted">กำลังโหลดข้อมูลหลักสูตร...</p>
            </div>
          </div>

          <!-- No Results -->
          <div *ngIf="!isLoading && filteredCourses.length === 0" class="no-results">
            <div class="text-center py-5">
              <i class="fas fa-book-open fa-3x text-muted mb-3"></i>
              <h5 class="text-muted">ไม่พบหลักสูตรที่ตรงตามเงื่อนไข</h5>
              <p class="text-muted">ลองปรับเปลี่ยนเงื่อนไขการค้นหาหรือล้างตัวกรอง</p>
              <button class="btn btn-outline-primary" (click)="clearFilters()">
                <i class="fas fa-refresh"></i>
                ล้างตัวกรอง
              </button>
            </div>
          </div>

          <!-- Courses Table -->
          <div *ngIf="!isLoading && filteredCourses.length > 0" class="table-container">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead class="table-dark">
                  <tr>
                    <th scope="col" class="text-center">ลำดับที่</th>
                    <th scope="col" class="sortable-header" (click)="onSort('title')">
                      คอร์สอบรม/สัมมนา
                      <i [class]="getSortIcon('title')"></i>
                    </th>
                    <th scope="col" class="sortable-header text-center" (click)="onSort('duration')">
                      CPD
                      <i [class]="getSortIcon('duration')"></i>
                    </th>
                    <th scope="col" class="text-center">รับรองโดย กลต.</th>
                    <th scope="col" class="sortable-header" (click)="onSort('startDate')">
                      วันที่เริ่มอบรม
                      <i [class]="getSortIcon('startDate')"></i>
                    </th>
                    <th scope="col" class="sortable-header" (click)="onSort('endDate')">
                      วันสุดท้ายของการอบรม
                      <i [class]="getSortIcon('endDate')"></i>
                    </th>
                    <th scope="col" class="sortable-header" (click)="onSort('status')">
                      สถานะของคอร์สอบรม
                      <i [class]="getSortIcon('status')"></i>
                    </th>
                    <th scope="col" class="sortable-header text-center" (click)="onSort('regisSeat')">
                      จำนวนผู้เข้าอบรม
                      <i [class]="getSortIcon('regisSeat')"></i>
                    </th>
                    <th scope="col" class="text-end">รายได้รวม</th>
                    <th scope="col" class="text-center">การดำเนินการ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let course of getPaginatedCourses(); let i = index; trackBy: trackByCourseId" class="clickable-row"
                    (click)="viewCourse(course)" [attr.title]="'คลิกเพื่อดูรายละเอียดหลักสูตร: ' + course.title">
                    <td class="text-center text-muted">{{ (page - 1) * pageSize + i + 1 }}</td>
                    <td>
                      <div class="course-info">
                        <div class="course-title">{{ course.title }}</div>
                        <div class="course-description text-muted">{{ course.description }}</div>
                      </div>
                    </td>
                    <td class="text-center">{{ course.duration }}</td>
                    <td class="text-center">
                      <span class="badge" [ngClass]="course.certificationBySEC ? 'bg-success' : 'bg-danger'">
                        {{ course.certificationBySEC ? 'Yes' : 'No' }}
                      </span>
                    </td>
                    <td>{{ formatDate(course.startDate) }}</td>
                    <td>{{ formatDate(course.endDate) }}</td>
                    <td>
                      <span [class]="getStatusBadgeClass(course)">
                        {{ course.courseStatus?.name || '-' }}
                      </span>
                    </td>
                    <td class="text-center">{{ course.regisSeat || 0 }}</td>
                    <td class="text-end">{{ getCourseRevenue(course) }}</td>
                    <td class="text-center action-cell" (click)="$event.stopPropagation()">
                      <div ngbDropdown class="d-inline-block action-dropdown" (click)="$event.stopPropagation()"
                        (openChange)="onDropdownOpenChange($event, course.id)" container="body" placement="bottom-end">
                        <button class="btn btn-sm btn-outline-primary dropdown-toggle" type="button"
                          id="dropdownMenuButton-{{course.id}}" ngbDropdownToggle>
                          <i class="fas fa-cog me-1"></i>จัดการ
                        </button>
                        <div class="dropdown-menu" ngbDropdownMenu
                          [attr.aria-labelledby]="'dropdownMenuButton-' + course.id">
                          <button class="dropdown-item" type="button" (click)="editCourse(course)">
                            <i class="fas fa-edit me-2"></i>แก้ไขหลักสูตร
                          </button>
                          <div class="dropdown-divider"></div>
                          <button class="dropdown-item text-danger" type="button" (click)="deleteCourse(course)">
                            <i class="fas fa-trash me-2"></i>ลบหลักสูตร
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="d-flex align-items-center justify-content-end gap-2 mb-2">
              <span class="text-muted small">แสดงผล:</span>
              <select class="form-select form-select-sm w-auto" [(ngModel)]="pageSize"
                (ngModelChange)="changePageSize(pageSize)" aria-label="จำนวนรายการต่อหน้า">
                <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }} รายการ</option>
              </select>
            </div>

            <!-- Pagination -->
            <div *ngIf="collectionSize > pageSize" class="d-flex justify-content-center mt-4">
              <ngb-pagination [(page)]="page" [pageSize]="pageSize" [collectionSize]="collectionSize" [maxSize]="5"
                [rotate]="true" [boundaryLinks]="true" (pageChange)="onPageChange($event)">
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>